import React, { useEffect } from "react";
import "../../assets/styles/Profile.css";
import { useState, useRef } from "react";
import Popup from "reactjs-popup";
import { color, motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import logo from "../../imgs/f8bet/logo.png";
import iconUser from "../../icons/f8bet/icon-user.png";
import iconPhone from "../../icons/f8bet/icon-phone.png";
import iconMail from "../../icons/f8bet/icon-mail.png";
import iconBank from "../../icons/f8bet/icon-bank.png";
import iconBirthday from "../../icons/f8bet/icon-birthday.png";
import iconPassLogin from "../../icons/f8bet/icon-pass-login.png";
import iconPassWithdraw from "../../icons/f8bet/icon-pass-withdraw.png";
import Collapsible from "react-collapsible";
import iconClose from "../../icons/icon-close.png";
import iconSendMail from "../../icons/icon-send-mail.png";
import iconSendPhone from "../../icons/icon-send-phone.png";
import iconWarning from "../../icons/icon-warning.png";
import iconSuccess from "../../icons/icon-success.png";
import { Button } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import iconArrow from "../../icons/icon-arrow.png";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loading from "../../components/helper/Loading.js";
import { config } from "../../config.js";
import post from "../../imgs/f8bet/post.png";
import {
  apiConfirmUpdate,
  apiUpdateAccount,
  apiCheckDataAccount,
  apiFormUpdateAccount,
  apiGetSetting,
  apiGetRequestHistory,
  apiGetBanks,
} from "../../services/api.service.js";

import * as yup from "yup";
import { red } from "@mui/material/colors";

function Profile() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Add error handling for missing state
    if (!location.state) {
      console.error("No state received in Profile");
      navigate("/");
      return;
    }

    const { userName, data, webSetting, typeStep1 } = location.state;
    console.log("Current webSetting:", webSetting); // Debug log

    // If webSetting is missing or null
    if (!webSetting) {
      console.log("Fetching webSetting...");
      const fetchWebSetting = async () => {
        try {
          const result = await apiGetSetting();
          console.log("Fetched webSetting result:", result); // Debug log

          if (result && result.status_code === 200) {
            // Only navigate if we actually got data
            if (result.data) {
              navigate("/profile", {
                replace: true,
                state: {
                  userName,
                  data,
                  webSetting: result.data,
                  typeStep1,
                },
              });
            } else {
              console.error("No webSetting data available");
              Swal.fire({
                icon: "error",
                text: "Không thể tải cấu hình. Vui lòng thử lại sau.",
              }).then(() => {
                navigate("/");
              });
            }
          }
        } catch (error) {
          console.error("Error fetching webSetting:", error);
          navigate("/");
        }
      };
      fetchWebSetting();
    }
  }, [location, navigate]);

  const [open, setOpen] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [typeModal, setTypeModal] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openResult, setOpenResult] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [infoFileUpload, setInfoFileUpload] = useState("");
  const [checkSelectFile, setCheckSelectFile] = useState(false);
  const [totalFiles, setTotalFiles] = useState(false);
  const [isSendMail, setIsSendMail] = useState(true);
  const { userName, data, webSetting, typeStep1 } = location.state || {};
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [requestCode, setRequestCode] = useState("");
  const [requestHistory, setRequestHistory] = useState(null);
  const [requestHistoryError, setRequestHistoryError] = useState("");
  const [openRequestHistoryResult, setOpenRequestHistoryResult] = useState(false);
  const [showRequestHistoryHelp, setShowRequestHistoryHelp] = useState(false);
  const [isRequestHistoryCollapsed, setIsRequestHistoryCollapsed] = useState(false);
  const [recentRequests, setRecentRequests] = useState((data?.recent_requests || []).slice(0, 2));
  const [submittedRequest, setSubmittedRequest] = useState(null);
  const [pollingChecks, setPollingChecks] = useState(0);
  const [isRefreshingRequest, setIsRefreshingRequest] = useState(false);
  const [requestRefreshMessage, setRequestRefreshMessage] = useState("");
  const fileInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_code: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  });
  const originalDataUpdate = {
    name: "",
    bank_type_change: "",
    bank_code: "",
    bank_name: "",
    bank_number: "",
    province: "",
    email: "",
    phone_number: "",
  };
  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const bankFieldSuffix = dataUpdate.bank_type_change === "Xóa số tài khoản" ? "Cần Xóa" : "Mới";
  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });
  const [errors, setErrors] = useState({});
  const [banks, setBanks] = useState([]); // danh sách ngân hàng cho khách chọn: [{ code, name }]
  let contentUpdate;

  // danh sách mục thông tin tài khoản không được phép thay đổi (BE trả về khi check tài khoản)
  const disabledUpdateTypes = data?.disabled_update_types || [];
  // class nút: mục bị giới hạn thì làm mờ, không cho bấm
  const actionClass = (updateType) => {
    return disabledUpdateTypes.includes(updateType) ? "action-btn action-disabled" : "action-btn";
  };

  // mô tả file upload và số ảnh tối thiểu theo mục thông tin khách đang chọn (setup ở admin)
  const uploadSetting = webSetting?.upload_descriptions || {};
  const uploadConfig = uploadSetting.by_update_type?.[user.update_type] || {};
  const uploadDescriptions = [];
  (uploadConfig.keys || []).forEach((key) => {
    const item = (uploadSetting.items || []).find((item) => item.key === key);
    if (item?.content) uploadDescriptions.push(item.content);
  });
  // chưa setup thì mặc định bằng số mô tả, không có mô tả thì 1 ảnh
  const minFiles = uploadConfig.min_files ?? (uploadDescriptions.length || 1);

  useEffect(() => {
    const fetchBanks = async () => {
      setBanks(await apiGetBanks());
    };
    fetchBanks();
  }, []);

  // chọn ngân hàng: lưu cả mã ngân hàng và tên ngân hàng
  const selectBankCheck = (event) => {
    const bank = banks.find((item) => item.code === event.target.value);
    setDataCheck({ ...dataCheck, bank_code: bank ? bank.code : "", bank_name: bank ? bank.name : "" });
  };
  const selectBankUpdate = (event) => {
    const bank = banks.find((item) => item.code === event.target.value);
    setDataUpdate({ ...dataUpdate, bank_code: bank ? bank.code : "", bank_name: bank ? bank.name : "" });
  };

  const requestStatusText = {
    no_process: "Đang chờ xử lý",
    approved: "Đã xử lý thành công",
    removed: "Đã từ chối",
  };
  const requestTypeText = {
    full_name: "Thay đổi họ và tên",
    phone_number: "Thay đổi số điện thoại",
    email: "Thay đổi email",
    bank: "Thay đổi tài khoản ngân hàng",
    birthday: "Thay đổi ngày sinh",
    forget_password: "Cấp lại mật khẩu đăng nhập",
    forget_password_withdraw: "Cấp lại mật khẩu rút tiền",
  };
  const getVerificationStatusText = (status, sendType) => {
    if (status === "success") return "Đã nhận xác thực hợp lệ";
    if (status === "invalid") return sendType === "email"
      ? "Đã nhận xác thực nhưng sai địa chỉ email"
      : "Đã nhận xác thực nhưng sai số điện thoại";
    return sendType === "email" ? "Chưa nhận được email xác thực" : "Chưa nhận được SMS xác thực";
  };
  const maskRequestCode = (code = "") => {
    const value = String(code);
    return value.startsWith("xxxxxx") ? value : `xxxxxx${value.slice(-2)}`;
  };

  useEffect(() => {
    if (!openConfirm || !submittedRequest?.request_code || submittedRequest.status !== "no_process" || pollingChecks >= 15) {
      return undefined;
    }

    const intervalId = setInterval(async () => {
      const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
      setPollingChecks((count) => count + 1);
      if (result?.code === 200 && result?.data?.request) {
        const request = result.data.request;
        setSubmittedRequest(request);
        setRecentRequests((items) => items.map((item) =>
          (item._request_code || item.request_code) === request.request_code
            ? { ...item, ...request, request_code: item.request_code }
            : item
        ).slice(0, 2));
      }
    }, 30 * 1000);

    return () => clearInterval(intervalId);
  }, [openConfirm, submittedRequest?.request_code, submittedRequest?.status, pollingChecks, userName]);

  const schema = yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup.string().email("Email is invalid").required("Email is required"),
    phoneNumber: yup
      .string()
      .matches(/^[0-9]+$/, "Phone number must be digits")
      .required("Phone number is required"),
  });

  const shouldNavigate =
    !userName || userName === "undefined" || !webSetting;
  useEffect(() => {
    const shouldNavigate =
      !userName || userName === "undefined" || !webSetting;
    if (shouldNavigate) {
      navigate("/");
    }
  }, [navigate, webSetting, userName]);

  if (!shouldNavigate) {
    const checkRequestHistory = async () => {
      const code = requestCode.trim();
      setRequestHistoryError("");
      if (!/^\d{8}$/.test(code)) {
        setRequestHistoryError("Vui lòng nhập đúng mã yêu cầu gồm 8 số.");
        return;
      }
      const result = await apiGetRequestHistory(userName, code);
      if (result?.code === 200 && result?.data?.request) {
        setRequestHistory(result.data.request);
        setOpenRequestHistoryResult(true);
      } else {
        setRequestHistoryError(result?.message || "Không tìm thấy yêu cầu.");
      }
    };

    const refreshSubmittedRequest = async () => {
      if (isRefreshingRequest || !submittedRequest?.request_code) return;
      setIsRefreshingRequest(true);
      setRequestRefreshMessage("");
      const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
      if (result?.code === 200 && result?.data?.request) {
        setSubmittedRequest(result.data.request);
        setRequestRefreshMessage(`Đã cập nhật trạng thái mới nhất lúc ${new Date().toLocaleTimeString("vi-VN")}`);
      } else {
        setRequestRefreshMessage("Không thể cập nhật trạng thái. Vui lòng thử lại.");
      }
      setIsRefreshingRequest(false);
    };

    const copySubmittedRequestCode = async () => {
      try {
        await navigator.clipboard.writeText(submittedRequest?.request_code || "");
        setRequestRefreshMessage(`Đã sao chép: ${submittedRequest?.request_code}`);
      } catch (error) {
        setRequestRefreshMessage("Không thể sao chép mã yêu cầu.");
      }
    };

    const updateUserField = (field, value) => {
      setUser((prevUser) => ({
        ...prevUser,
        [field]: value,
      }));
    };

    const inputDataCheck = (event) => {
      let { name, value } = event.target;
      if (name === "phone_number") {
        value = value.replace(/^(\+?84)/, "0");
      }
      if (name === "name") {
        value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      }
      setDataCheck({
        ...dataCheck,
        [name]: value,
      });
    };

    const inputDataUpdate = (event) => {
      const { name, value } = event.target;
      setDataUpdate({
        ...dataUpdate,
        [name]: value,
      });
    };

    const openModal = (type) => {
      if (type === "FULL_NAME") {
        updateUserField("update_type", "full_name");
        setTypeModal("FULL_NAME");
      } else if (type === "PHONE_NUMBER") {
        updateUserField("update_type", "phone_number");
        setTypeModal("PHONE_NUMBER");
      } else if (type === "MAIL") {
        updateUserField("update_type", "email");
        setTypeModal("MAIL");
      } else if (type === "BANK") {
        updateUserField("update_type", "bank");
        setTypeModal("BANK");
      } else if (type === "BIRTHDAY") {
        updateUserField("update_type", "birthday");
        setTypeModal("BIRTHDAY");
      } else if (type === "PASS_LOGIN") {
        updateUserField("update_type", "forget_password");
        setTypeModal("PASS_LOGIN");
      } else if (type === "PASS_WITHDRAW") {
        updateUserField("update_type", "forget_password_withdraw");
        setTypeModal("PASS_WITHDRAW");
      }
      document.body.style.overflow = "hidden";
      setOpen(true);
    };

    const openModalConfirm = (type) => {
      setOpenConfirm(true);
      document.getElementsByClassName("popup-overlay")[0].style.visibility =
        "hidden";
    };

    const validateForm = (sendType = "", checkData = dataCheck) => {
      let errors = {};
      let formIsValid = true;

      // Kiểm tra trường Name
      if (!checkData.name) {
        formIsValid = false;
        errors.name = "Vui lòng nhập Họ và Tên";
      }

      // Kiểm tra trường phone_number
      if (data.phone_number && sendType === "phone_number") {
        if (!checkData.phone_number) {
          formIsValid = false;
          errors.phone_number = "Vui lòng nhập Số Điện Thoại";
        } else if (!/^(\d{10})|(no)$/.test(checkData.phone_number)) {
          formIsValid = false;
          errors.phone_number = "Số Điện Thoại không hợp lệ";
        }
      }

      // Kiểm tra trường email
      if (data.email && sendType === "mail") {
        if (!checkData.email) {
          formIsValid = false;
          errors.email = "Vui lòng nhập Email";
        } else if (!/\S+@\S+\.\S+/.test(checkData.email)) {
          formIsValid = false;
          errors.email = "Email không hợp lệ";
        }
      }

      if (data.bank_number) {
        // Kiểm tra trường bank_name
        if (!checkData.bank_name) {
          formIsValid = false;
          errors.bank_name = "Vui lòng chọn Ngân Hàng";
        }

        // Kiểm tra trường bank_number
        if (!checkData.bank_number) {
          formIsValid = false;
          errors.bank_number = "Vui lòng nhập Số Tài Khoản";
        }
      }
      switch (typeModal) {
        case "FULL_NAME": // Kiểm tra trường Name update
          if (!dataUpdate.name) {
            formIsValid = false;
            errors.nameUpdate = "Vui lòng nhập Họ và Tên mới";
          } else {
            contentUpdate = dataUpdate.name;
          }
          break;
        case "PHONE_NUMBER": // Kiểm tra trường phone_number
          if (!dataUpdate.phone_number) {
            formIsValid = false;
            errors.phoneNumberUpdate = "Vui lòng nhập Số Điện Thoại mới";
          } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
            formIsValid = false;
            errors.phoneNumberUpdate = "Số Điện Thoại mới không hợp lệ";
          } else {
            contentUpdate = dataUpdate.phone_number;
          }
          break;
        case "MAIL": // Kiểm tra trường email
          if (!dataUpdate.email) {
            formIsValid = false;
            errors.emailUpdate = "Vui lòng nhập Email mới";
          } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
            formIsValid = false;
            errors.emailUpdate = "Email mới không hợp lệ";
          } else {
            contentUpdate = dataUpdate.email;
          }
          break;
        case "BANK": // Kiểm tra value bank
          if (!dataUpdate.bank_type_change) {
            formIsValid = false;
            errors.bankTypeChange = "Vui lòng chọn yêu cầu thay đổi";
          }
          if (!dataUpdate.bank_name) {
            formIsValid = false;
            errors.bankNameUpdate = `Vui lòng chọn Ngân Hàng ${bankFieldSuffix}`;
          }
          if (!dataUpdate.bank_number) {
            formIsValid = false;
            errors.bankNumberUpdate = `Vui lòng nhập Số Tài Khoản ${bankFieldSuffix}`;
          } else {
            contentUpdate =
              dataUpdate.bank_type_change +
              " - " +
              dataUpdate.bank_number +
              " - " +
              dataUpdate.bank_name +
              " - " +
              dataUpdate.province;
          }
          if (!dataUpdate.province) {
            formIsValid = false;
            errors.province = `Vui lòng nhập chi nhánh Ngân Hàng ${bankFieldSuffix}`;
          }
          break;

        case "BIRTHDAY": // Kiểm tra trường birth day
          if (!dataUpdate.birth_day) {
            formIsValid = false;
            errors.birthDayUpdate = "Vui lòng chọn ngày tháng năm sinh";
          } else {
            contentUpdate = dataUpdate.birth_day;
          }
          break;
        case "PASS_LOGIN":
          contentUpdate = "Lấy mật khẩu đăng nhập";
          break;
        case "PASS_WITHDRAW":
          contentUpdate = "Lấy mật khẩu rút tiền";
          break;
        default:
          break;
      }
      console.log(errors);
      setErrors(errors);
      return formIsValid;
    };

    const modalConfirmUpdate = async (type) => {
      if (type === "files") {
        if (validateForm(type)) {
          user.send_type = "files";
          updateUserField("send_type", "files");
          updateUser("files");
        }
        return;
      }

      if (!validateForm("files")) {
        return;
      }

      const isEmail = type === "mail";
      const result = await Swal.fire({
        icon: "warning",
        title: isEmail
          ? "Vui lòng nhập Email đã liên kết"
          : "Vui lòng nhập Số Điện Thoại đã liên kết",
        // text: isEmail
        //   ? "Email này sẽ được dùng để xác thực thông tin."
        //   : "Bạn sẽ dùng số điện thoại này để gửi tin nhắn xác thực thông tin.",
        input: isEmail ? "email" : "text",
        inputValue: isEmail ? dataCheck.email : dataCheck.phone_number,
        inputPlaceholder: isEmail ? "Email" : "Số Điện Thoại",
        showCancelButton: true,
        confirmButtonText: "Tiếp tục",
        cancelButtonText: "Quay lại",
        reverseButtons: true,
        inputValidator: (value) => {
          const normalizedValue = isEmail
            ? value.trim()
            : value.trim().replace(/^(\+?84)/, "0");

          if (!normalizedValue) {
            return isEmail
              ? "Vui lòng nhập Email"
              : "Vui lòng nhập Số Điện Thoại";
          }
          if (isEmail && !/\S+@\S+\.\S+/.test(normalizedValue)) {
            return "Email không hợp lệ";
          }
          if (!isEmail && !/^\d{10}$/.test(normalizedValue)) {
            return "Số Điện Thoại không hợp lệ";
          }
          return undefined;
        },
      });

      if (result.isConfirmed) {
        const value = isEmail
          ? result.value.trim()
          : result.value.trim().replace(/^(\+?84)/, "0");
        const nextDataCheck = {
          ...dataCheck,
          [isEmail ? "email" : "phone_number"]: value,
        };
        setDataCheck(nextDataCheck);
        updateUser(type, nextDataCheck);
      }
    };
    const updateUser = async (type, checkData = dataCheck) => {
      let numberImagesAttach = 0;
      setLoading(true);
      if (validateForm(type, checkData)) {
        if (type === "mail") {
          user.send_type = "email";
          setIsSendMail(true);
        } else if (type === "phone_number") {
          user.send_type = "phone_number";
          setIsSendMail(false);
        } else if (type === "files") {
          numberImagesAttach = minFiles;
          user.send_type = "files";
          setIsSendMail(false);
        }
        let body = {
          ...user,
          data_check: {
            ...checkData,
          },
          data_update: {
            update_type: user.update_type,
            content: contentUpdate,
            // đổi ngân hàng: gửi thêm mã ngân hàng + số tài khoản để BE không phải tách từ content
            ...(user.update_type === "bank" && {
              bank_code: dataUpdate.bank_code,
              bank_number: dataUpdate.bank_number,
            }),
          },
        };
        let checkDataOld = await apiCheckDataAccount(body);
        if (checkDataOld) {
          // hiển thị yêu cầu upload files
          numberImagesAttach =
            numberImagesAttach > checkDataOld.numberImagesAttach
              ? numberImagesAttach
              : checkDataOld.numberImagesAttach;
          if (
            numberImagesAttach > 0 &&
            totalFiles < numberImagesAttach &&
            (checkDataOld.allowSubmit > 0 || type === "files")
          ) {
            setLoading(false);
            openModalUpload("number_images_attach", numberImagesAttach);
            return;
          }

          // check data nhập vào với data cũ đúng hết tất cả các mục hay không
          let confirmUpdate = checkDataOld.result;
          let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
          updateUserField("auto_check", value_auto_check);
          body.auto_check = value_auto_check;

          //nếu thông tin đúng hết hoặc đã nhập lại từ 5 lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
          if (
            confirmUpdate ||
            (timesCheckData >= 20 && checkDataOld.allowSubmit > 0)
          ) {
            confirmUpdateUser(body, type);
          } else {
            let title =
                checkDataOld.submitPhoneNumber == 0 &&
                  type === "phone_number"
                ? "Quý khách nhập không đúng SĐT đã liên kết, vui lòng kiểm tra lại thông tin hoặc sử dụng cách khác."
                : checkDataOld.submitEmail == 0 && type === "mail"
                ? "Quý khách nhập không đúng Email liên kết, vui lòng kiểm tra lại thông tin hoặc sử dụng cách khác"
                : "";

            // Thông tin xác thực hợp lệ: tiếp tục gửi, không hiển thị
            // thông báo phần trăm thông tin cũ nhập đúng.
            if (!title) {
              confirmUpdateUser(body, type);
              return;
            }

            setLoading(false);
            Swal.fire({
              icon: "warning",
              title: "Chú ý",
              text: title,
              showCancelButton: true,
              cancelButtonText: "Nhập lại",
              confirmButtonText: "Tiếp tục gửi",
              // chỉ khi có ít nhất 1 thông tin (số điện thoại hoặc email) đúng thì mới hiển thị nút confirm gửi yêu cầu
              showConfirmButton:
                type === "files" ||
                (checkDataOld.submitPhoneNumber === 1 &&
                  type === "phone_number") ||
                (checkDataOld.submitEmail === 1 && type === "mail"),
              reverseButtons: true,
            }).then((result) => {
              if (result.isConfirmed) {
                setLoading(true);
                confirmUpdateUser(body, type);
              } else if (result.isDismissed) {
                setTimesCheckData((currentTimes) => currentTimes + 1);
                if (type === "mail" || type === "phone_number") {
                  modalConfirmUpdate(type);
                }
              }
            });
          }
        }
      }
      setLoading(false);
    };

    const confirmUpdateUser = async (body, type) => {
      let updateInfo = await apiFormUpdateAccount(body, selectedFiles);
      setLoading(false);
      const newRequestCode = updateInfo?.request_code;
      if (newRequestCode) {
        const newRequest = {
          ...body,
          request_code: newRequestCode,
          _request_code: newRequestCode,
          status: "no_process",
          verification_status: "not_received",
          createdAt: new Date().toISOString(),
        };
        user.request_code = newRequestCode;
        setUser((currentUser) => ({ ...currentUser, request_code: newRequestCode }));
        setSubmittedRequest(newRequest);
        setRecentRequests((items) => [
          { ...newRequest, request_code: `xxxxxx${newRequestCode.slice(-2)}` },
          ...items,
        ].slice(0, 2));
        setPollingChecks(0);
        setRequestRefreshMessage("");
        openModalConfirm(type);
      }
      let content;
      switch (user.update_type) {
        case "full_name":
          content = `Tên đăng nhập: ${user.account}\r\nHọ tên cũ: ${dataCheck.name}\r\nHọ tên mới: ${dataUpdate.name}\r\nNgân hàng: ${dataCheck.bank_number}-${dataCheck.bank_name}`;
          break;
        case "phone_number":
          content = `Tên đăng nhập: ${user.account}\r\nSố điện thoại mới: ${dataUpdate.phone_number}`;
          break;
        case "email":
          content = `Tên đăng nhập: ${user.account}\r\nEmail mới: ${dataUpdate.email}`;
          break;
        case "bank":
          content = `Tên đăng nhập: ${user.account}\r\nYêu cầu: ${dataUpdate.bank_type_change}\r\nNgân hàng: ${dataUpdate.bank_number}-${dataUpdate.bank_name}`;
          break;
        case "forget_password":
          content = `Tên đăng nhập: ${user.account}\r\nSố tiền nạp gần nhất(nếu có): \r\nYêu cầu lấy mật khẩu đăng nhập`;
          break;
        case "forget_password_withdraw":
          content = `Tên đăng nhập: ${user.account}\r\nSố tiền nạp gần nhất(nếu có): \r\nYêu cầu lấy mật khẩu rút tiền`;
          break;
        default:
          content = ``;
          break;
      }
      navigator.clipboard.writeText(content);
    };

    const resetValidate = async (type) => {
      validateForm();
      setErrors({});
    };

    const resetDataUpdate = async (type) => {
      setDataUpdate(originalDataUpdate);
    };

    const closeModalConfirm = () => {
      setOpenConfirm(false);
      document.getElementsByClassName("popup-overlay")[0].style.visibility =
        "visible";
    };

    // không còn sử dụng
    // const openModalSuccess = async () => {

    //   let body = {
    //     user: user,
    //     userInforCheck: dataCheck,
    //     userInforPending: dataUpdate,
    //   };
    //   let checkConfirmUpdate = await apiConfirmUpdate(body);
    //   setCheckConfirm(checkConfirmUpdate);
    //   setOpen(false);
    //   setOpenConfirm(false);
    //   setOpenResult(true);
    // };

    const openModalUpload = (forgot = "", numberImagesAttach = null) => {
      // hiển thị mô tả chọn file theo nội dung được setup ở admin và tự động điền no vào input của forgot
      let descriptionFileUpload = "";
      switch (forgot) {
        // các nút nhấn quên thông tin
        case "forgot_phone_number":
          descriptionFileUpload = "";
          if (webSetting?.des_up_files_phone_number?.length > 0) {
            webSetting.des_up_files_phone_number.forEach((element) => {
              descriptionFileUpload += element + "<br/>";
            });
          }
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          if (!dataCheck.phone_number) {
            setDataCheck({
              ...dataCheck,
              phone_number: "no",
            });
          }
          break;
        case "forgot_email":
          descriptionFileUpload = "";
          if (webSetting?.des_up_files_email?.length > 0) {
            webSetting.des_up_files_email.forEach((element) => {
              descriptionFileUpload += element + "<br/>";
            });
          }
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          if (!dataCheck.email) {
            setDataCheck({
              ...dataCheck,
              email: "no@email.com",
            });
          }
          break;
        case "forgot_bank":
          descriptionFileUpload = "";
          if (webSetting?.des_up_files_bank?.length > 0) {
            webSetting.des_up_files_bank.forEach((element) => {
              descriptionFileUpload += element ? element + "<br/>" : "";
            });
          }
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          if (!dataCheck.bank_name) {
            setDataCheck({
              ...dataCheck,
              bank_name: "no",
            });
          }
          if (!dataCheck.bank_number) {
            setDataCheck({
              ...dataCheck,
              bank_number: "no",
              bank_name: dataCheck.bank_name ? dataCheck.bank_name : "no",
            });
          }
          break;

        case "number_images_attach":
          // khi submit thiếu thông tin: mô tả theo mục thông tin khách đang chọn (setup ở admin)
          descriptionFileUpload = uploadDescriptions.length > 0
            ? "Bạn vui lòng tải lên ít nhất " + numberImagesAttach + " trong " + uploadDescriptions.length + " hình ảnh dưới để xác minh tài khoản<br/><br/>"
            : "Bạn vui lòng tải lên ít nhất " + numberImagesAttach + " hình ảnh để xác minh tài khoản<br/><br/>";
          uploadDescriptions.forEach((element, index) => {
            descriptionFileUpload += (index + 1) + ". " + element + "</br>";
          });
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          break;
        default:
          break;
      }
      setOpenUploadFile(true);
      setInfoFileUpload(descriptionFileUpload);
    };

    const handleButtonClick = () => {
      // Kích hoạt click vào button chọn file
      fileInputRef.current.click();
    };

    // Hàm xử lý khi file được chọn
    const handleFileChange = (event) => {
      const files = Array.from(event.target.files);
      if (files.length + totalFiles > 10) {
        alert(
          `Bạn chỉ có thể thêm tối đa 10 file. Hiện đã chọn ${
            files.length + totalFiles
          } file.`
        );
      } else if (files.length > 0) {
        setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
        setTotalFiles(files.length + totalFiles);
      }
      event.target.value = null;
    };
    const removeFile = (index) => {
      setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
      setTotalFiles(totalFiles - 1);
    };

    return (
      <div className="container">
        {loading && <Loading loading={loading} />}
        <motion.div
          // className="app"
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // transition={{ duration: 5 }}
          // className="app"
          // initial={{ x: "-100vw", opacity: 0 }}
          // animate={{ x: 0, opacity: 1 }}
          // exit={{ x: "100vw", opacity: 0 }}
          // transition={{ type: "spring", stiffness: 100, damping: 20 }}
          className="app"
          initial={{ x: "100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100vw", opacity: 0 }}
          transition={{
            type: "spring",
            stiffness: 1000,
            damping: 200,
            duration: 10,
          }}
        >
          <Header isPageSearch={false} webSetting={webSetting}/>

          <div className="content">
            <div className="profile">
              {/* <InfoUser /> */}
              <div>
              </div>
              <div className="profile-action">
                <div className="request-history">
                  <div className="request-history-heading">
                    <span className="profile-titlte">LỊCH SỬ YÊU CẦU  &nbsp;
                      <span className="request-history-help" onMouseEnter={() => setShowRequestHistoryHelp(true)} onMouseLeave={() => setShowRequestHistoryHelp(false)}>
                        <button type="button" className="request-history-help-icon" aria-label="Thông tin lịch sử yêu cầu" onClick={() => setShowRequestHistoryHelp((value) => !value)}>!</button>
                        {showRequestHistoryHelp && <div className="request-history-help-content">Danh sách chỉ hiển thị tối đa 2 yêu cầu gần nhất trong 48 giờ. Nhập mã yêu cầu 8 số để xem chi tiết kết quả xử lý.</div>}
                      </span>
                    </span>
                    {/* <button type="button" className="request-history-collapse-button" onClick={() => setIsRequestHistoryCollapsed((value) => !value)}>{isRequestHistoryCollapsed ? "+" : "−"}</button> */}
                  </div>
                  {!isRequestHistoryCollapsed && recentRequests.length > 0 && <div className="recent-requests">
                    {recentRequests.map((request, index) => <div className={`recent-request-item status-${request.status}`} key={`${request._request_code || request.request_code}-${index}`}>
                      <div className="recent-request-main"><strong>{requestTypeText[request.update_type] || request.update_type}</strong><span className="recent-request-code">Mã yêu cầu: {maskRequestCode(request.request_code)}</span></div>
                      <div className="recent-request-meta">
                        <span className={`recent-request-status status-${request.status}`}>{requestStatusText[request.status] || request.status}</span>
                        {request.status === "no_process" && ["email", "phone_number"].includes(request.send_type) && <span className={`verification-status verification-${request.verification_status || "not_received"}`}>{getVerificationStatusText(request.verification_status || "not_received", request.send_type)}</span>}
                      </div>
                    </div>)}
                  </div>}
                  {!isRequestHistoryCollapsed && <div className="request-history-form">
                    <input type="text" inputMode="numeric" maxLength="8" value={requestCode} onChange={(event) => { setRequestCode(event.target.value.replace(/\D/g, "")); setRequestHistoryError(""); }} onKeyDown={(event) => event.key === "Enter" && checkRequestHistory()} placeholder="Nhập mã yêu cầu 8 số" />
                    <button type="button" onClick={checkRequestHistory}>Kiểm tra</button>
                  </div>}
                  {!isRequestHistoryCollapsed && requestHistoryError && <p className="request-history-error">{requestHistoryError}</p>}
                </div>
                <span className="profile-titlte">
                  THAY ĐỔI MỤC THÔNG TIN MỚI
                </span>
                <div className="actions">
                  <div className="action">
                    {(typeStep1 !== "pass") && (
                    <>
                    <div className="action-inline">
                      <div className="action-btn-wrapper">
                        <button
                          className={actionClass("full_name")}
                          disabled={disabledUpdateTypes.includes("full_name")}
                          onClick={() => openModal("FULL_NAME")}
                        >
                          <img src={iconUser} alt="icon-user" />
                          THAY ĐỔI HỌ VÀ TÊN
                        </button>
                      </div>
                      <div className="action-btn-wrapper">
                        <button
                          className={actionClass("phone_number")}
                          disabled={disabledUpdateTypes.includes("phone_number")}
                          onClick={() => openModal("PHONE_NUMBER")}
                        >
                          <img src={iconPhone} alt="icon-phone" />
                          THAY ĐỔI SĐT
                        </button>
                      </div>
                    </div>
                    <div className="action-inline">
                      <div className="action-btn-wrapper">
                        <button
                          className={actionClass("email")}
                          disabled={disabledUpdateTypes.includes("email")}
                          onClick={() => openModal("MAIL")}
                        >
                          <img src={iconMail} alt="icon-mail" />
                          THAY ĐỔI EMAIL
                        </button>
                      </div>
                      <div className="action-btn-wrapper">
                        <button
                          className={actionClass("bank")}
                          disabled={disabledUpdateTypes.includes("bank")}
                          onClick={() => openModal("BANK")}
                        >
                          <img src={iconBank} alt="icon-bank" />
                          ĐỔI STK NGÂN HÀNG
                        </button>
                      </div>
                    </div>
                    </>
                    )}
                    <div className="action-inline">
                      <div className="action-btn-wrapper">
                        <button
                          className={actionClass("forget_password")}
                          disabled={disabledUpdateTypes.includes("forget_password")}
                          onClick={() => openModal("PASS_LOGIN")}
                        >
                          <img src={iconPassLogin} alt="icon-pass-login" />
                          MẬT KHẨU ĐĂNG NHẬP
                        </button>
                      </div>
                      <div className="action-btn-wrapper">
                        <button
                          className={actionClass("forget_password_withdraw")}
                          disabled={disabledUpdateTypes.includes("forget_password_withdraw")}
                          onClick={() => openModal("PASS_WITHDRAW")}
                        >
                          <img src={iconPassWithdraw} alt="icon-pass-withdraw" />
                          MẬT KHẨU RÚT TIỀN
                        </button>
                      </div>
                    </div>
                    {/* <div className="action-btn-wrapper">
                      <button
                        className="action-btn"
                        onClick={() => openModal("BIRTHDAY")}
                      >
                        <img
                          src={iconBirthday}
                          style={{ color: "#d50000" }}
                          alt="icon-birthday"
                        />
                        &nbsp; THAY ĐỔI NGÀY SINH
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <Popup
              open={open}
              onClose={() => {
                setOpen(false);
                document.body.style.overflow = "auto";
              }}
              position={"center"}
              closeOnDocumentClick={false}
              nested
            >
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                id="modal-info"
                className="modal-info"
              >
                <div className="header-logo">
                  <div className="main-logo">
                    <img src={logo} alt="logo"></img>
                  </div>
                </div>
                <div className="bg-content-edit">
                  <div className="modal-close">
                    <button
                      className="icon-close"
                      onClick={() => {
                        setOpen(false);
                        resetValidate();
                        resetDataUpdate();
                      }}
                      onAnimationEnd={() => setOpen(false)}
                    >
                      <img src={iconClose} alt="icon-close" />
                    </button>
                  </div>
                  {/* <div className="info-current">
                    <Collapsible
                      open={true}
                      trigger={[
                        "THÔNG TIN CÁ NHÂN",
                        <img
                          src={iconArrow}
                          key="icon-arrow"
                          alt="icon-arrow"
                        />,
                      ]}
                    >
                      <InfoUser />
                    </Collapsible>
                  </div> */}
                  <div className="confirm-info-old">
                    <span className="modal-titlte">
                      VUI LÒNG NHẬP THÔNG TIN ĐÃ LIÊN KẾT
                    </span>
                    <div className="input-info">
                      <input
                        type="text"
                        name="name"
                        value={dataCheck.name}
                        onChange={inputDataCheck}
                        placeholder="Họ Và Tên (vd: NGUYEN VAN A)"
                      />
                      {errors.name && <p className="error">{errors.name}</p>}
                      {/* <div className="input-button" >
                      <input type="text" name="phone_number" value={dataCheck.phone_number} onChange={inputDataCheck} placeholder="Số Điện Thoại"
                        style={{
                          width: '100%',
                          paddingRight: '150px',
                          boxSizing: 'border-box',
                        }}
                      />
                      <button onClick={() => openModalUpload("forgot_phone_number")}>
                        Không nhớ SĐT
                      </button>
                    </div> */}
                      {/* <div className="input-button" >
                      <input type="text" name="email" value={dataCheck.email} onChange={inputDataCheck} placeholder="Email"
                        style={{
                          width: '100%',
                          paddingRight: '150px',
                          boxSizing: 'border-box',
                        }}
                      />
                      <button onClick={() => openModalUpload("forgot_email")}>
                        Không nhớ email
                      </button>
                    </div> */}
                      <select
                        name="bank_code"
                        value={dataCheck.bank_code}
                        onChange={selectBankCheck}
                      >
                        <option value="">Chọn ngân hàng</option>
                        {banks.map((bank) => (
                          <option key={bank.code} value={bank.code}>
                            {bank.name}
                          </option>
                        ))}
                      </select>
                      {errors.bank_name && (
                        <p className="error">{errors.bank_name}</p>
                      )}
                      {/* <div className="input-button last-child" >
                      <input type="text" name="bank_number" value={dataCheck.bank_number} onChange={inputDataCheck} placeholder="Số Tài Khoản"/>
                      <button onClick={() => openModalUpload("forgot_bank")}>
                        Không nhớ STK
                      </button>
                    </div> */}
                      <input
                        type="text"
                        name="bank_number"
                        value={dataCheck.bank_number}
                        onChange={inputDataCheck}
                        placeholder="Số Tài Khoản"
                      />
                      {errors.bank_number && (
                        <p className="error">{errors.bank_number}</p>
                      )}
                    </div>
                  </div>
                  <div className="confirm-info-new">
                    <span className="modal-titlte">{
                      typeModal === "PASS_LOGIN" 
                      ? "LẤY MẬT KHẨU ĐĂNG NHẬP" 
                      : typeModal === "PASS_WITHDRAW"
                        ? "LẤY MẬT KHẨU RÚT TIỀN"
                        : "THAY ĐỔI THÔNG TIN MỚI"
                    }</span>
                    {
                      {
                        FULL_NAME: (
                          <div className="input-info">
                            <input
                              type="text"
                              name="name"
                              onChange={inputDataUpdate}
                              placeholder="Họ Tên Mới"
                            />
                            {errors.nameUpdate && (
                              <p className="error">{errors.nameUpdate}</p>
                            )}
                          </div>
                        ),
                        PHONE_NUMBER: (
                          <div className="input-info">
                            <input
                              type="text"
                              name="phone_number"
                              onChange={inputDataUpdate}
                              placeholder="Số Điện Thoại Mới"
                            />
                            {errors.phoneNumberUpdate && (
                              <p className="error">
                                {errors.phoneNumberUpdate}
                              </p>
                            )}
                          </div>
                        ),
                        MAIL: (
                          <div className="input-info">
                            <input
                              type="text"
                              name="email"
                              onChange={inputDataUpdate}
                              placeholder="Email Mới"
                            />
                            {errors.emailUpdate && (
                              <p className="error">{errors.emailUpdate}</p>
                            )}
                          </div>
                        ),
                        BANK: (
                          <div className="input-info">
                            <select
                              name="bank_type_change"
                              value={dataUpdate.bank_type_change}
                              onChange={inputDataUpdate}
                            >
                              <option value="">Chọn yêu cầu thay đổi</option>
                              {config.LIST_REQUEST_BANK.map((request) => (
                                <option key={request} value={request}>
                                  {request}
                                </option>
                              ))}
                            </select>
                            {errors.bankTypeChange && (
                              <p className="error">{errors.bankTypeChange}</p>
                            )}
                            <select
                              name="bank_code"
                              value={dataUpdate.bank_code}
                              onChange={selectBankUpdate}
                            >
                              <option value="">{`Chọn Ngân Hàng ${bankFieldSuffix}`}</option>
                              {banks.map((bank) => (
                                <option key={bank.code} value={bank.code}>
                                  {bank.name}
                                </option>
                              ))}
                            </select>
                            {errors.bankNameUpdate && (
                              <p className="error">{errors.bankNameUpdate}</p>
                            )}
                            <input
                              type="text"
                              name="bank_number"
                              onChange={inputDataUpdate}
                              placeholder={`Số Tài Khoản Ngân Hàng ${bankFieldSuffix}`}
                            />
                            {errors.bankNumberUpdate && (
                              <p className="error">{errors.bankNumberUpdate}</p>
                            )}
                            <input
                              type="text"
                              name="province"
                              onChange={inputDataUpdate}
                              placeholder={`Chi Nhánh Ngân Hàng ${bankFieldSuffix}`}
                            />
                            {errors.province && (
                              <p className="error">{errors.province}</p>
                            )}
                          </div>
                        ),
                        BIRTHDAY: (
                          <div className="input-info">
                            <input
                              type="date"
                              name="birth_day"
                              onChange={inputDataUpdate}
                              placeholder="ngày tháng năm sinh"
                              defaultValue="2000-12-01"
                            />
                            {errors.birthDayUpdate && (
                              <p className="error">{errors.birthDayUpdate}</p>
                            )}
                          </div>
                        ),
                      }[typeModal]
                    }
                  </div>
                  <div className="mode-verify">
                    <span className="modal-titlte">
                      VUI LÒNG LỰA CHỌN HÌNH THỨC GỬI XÁC THỰC
                    </span>
                    <div className="action action-verify">
                      {data.email && typeModal !== "BIRTHDAY" && (
                        <button
                          onClick={() => modalConfirmUpdate("mail")}
                          className="action-verify-btn"
                        >
                          <img src={iconSendMail} alt="icon-bank" />
                          &nbsp; XÁC THỰC EMAIL
                        </button>
                      )}
                      {(data.phone_number && typeModal !== "BIRTHDAY") &&
                        <button
                          onClick={() => modalConfirmUpdate("phone_number")}
                          className="action-verify-btn"
                        >
                          <img src={iconSendPhone} alt="icon-bank" />
                          &nbsp; XÁC THỰC SĐT
                        </button>
                      }
                    </div>
                    <div className="action action-verify">
                      <span className="text-description">
                        Nếu quý khách không có Email hoặc SĐT để gửi thông tin, vui lòng nhấn nút dưới đây để thực hiện thay thế
                      </span>
                      <button
                        id="confirm_files_btn"
                        onClick={() => modalConfirmUpdate("files")}
                      >
                        TẢI LÊN HÌNH ẢNH HOẶC VIDEO THAY THẾ XÁC THỰC
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>
            </Popup>
            <Popup
              open={openRequestHistoryResult}
              onClose={() => setOpenRequestHistoryResult(false)}
              position="center"
              closeOnDocumentClick
              overlayStyle={{ display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0, 0, 0, 0.35)" }}
              contentStyle={{ position: "relative", inset: "auto", width: "auto", padding: 0, border: "none", background: "transparent" }}
            >
              <div className="request-history-modal">
                <button className="request-history-modal-close" onClick={() => setOpenRequestHistoryResult(false)}><img src={iconClose} alt="Đóng" /></button>
                {requestHistory && <div className={`request-history-result status-${requestHistory.status}`}>
                  <h3>KẾT QUẢ YÊU CẦU</h3>
                  <p><strong>Loại yêu cầu:</strong> {requestTypeText[requestHistory.update_type] || requestHistory.update_type}</p>
                  {requestHistory.data_update?.content && <p><strong>Nội dung yêu cầu:</strong> {requestHistory.data_update.content}</p>}
                  <p><strong>Trạng thái:</strong> {requestStatusText[requestHistory.status] || requestHistory.status}</p>
                  {requestHistory.status === "no_process" && ["email", "phone_number"].includes(requestHistory.send_type) && <p className={`verification-status verification-${requestHistory.verification_status || "not_received"}`}>{getVerificationStatusText(requestHistory.verification_status || "not_received", requestHistory.send_type)}</p>}
                  {(requestHistory.note || requestHistory.result) && <div className="request-result-note"><strong>Ghi chú/Kết quả:</strong><HtmlNote html={requestHistory.note || requestHistory.result} /></div>}
                  {requestHistory.createdAt && <p><strong>Ngày gửi:</strong> {new Date(requestHistory.createdAt).toLocaleString("vi-VN")}</p>}
                </div>}
              </div>
            </Popup>
            <Popup
              open={openConfirm}
              closeOnDocumentClick={false}
              onClose={closeModalConfirm}
              position={"center"}
              nested
            >
              <motion.div
                initial={{ opacity: 0, y: 75 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                id="modal-confirm"
                className="modal-confirm"
              >
                <div className="modal-close">
                  <a className="icon-close" onClick={closeModalConfirm}>
                    <img src={iconClose} alt="icon-close" />
                  </a>
                </div>
                <div className="modal-confirm-content">
                  {/* <img className="icon-warning" src={iconWarning} /> */}
                  {user.send_type === "email" ? (
                    <p>
                      Vui lòng sử dụng email đã liên kết{" "}
                      <span style={{ color: "green" }}>{data.email}</span>, gửi
                      tin nhắn tới email {config.site.toUpperCase()}{" "}
                      <span style={{ color: "red" }}>{webSetting?.email}</span>,
                      với nội dung:
                    </p>
                  ) : user.send_type === "phone_number" ? (
                    <p>
                      Vui lòng sử dụng số điện thoại đã liên kết{" "}
                      <span style={{ color: "green" }}>
                        {data.phone_number}
                      </span>
                      , gửi tin nhắn tới số điện thoại{" "}
                      {config.site.toUpperCase()}{" "}
                      <span style={{ color: "red" }}>
                        {webSetting?.phone_number}
                      </span>
                      , với nội dung:
                    </p>
                  ) : (
                    <p>
                      F8bet đã ghi nhận yêu cầu của quý khách. Vui lòng đợi xét
                      duyệt.
                    </p>
                  )}
                  {user.send_type !== "files" && (
                    <DataConfirm
                      user={user}
                      dataCheck={dataCheck}
                      dataUpdate={dataUpdate}
                      webSetting={webSetting}
                    />
                  )}
                  {submittedRequest && <div className={`request-processing-status status-${submittedRequest.status} verification-${["email", "phone_number"].includes(submittedRequest.send_type) ? submittedRequest.verification_status || "not_received" : "success"}`}>
                    {submittedRequest.status === "no_process" && <div className={`request-live-update-notice ${pollingChecks >= 15 ? "request-live-update-stopped" : ""}`} role="status" aria-live="polite">
                      {pollingChecks < 15 ? <span className="request-loading-icon" aria-hidden="true" /> : <span className="request-update-paused-icon" aria-hidden="true">✓</span>}
                      <div>
                        <strong>{pollingChecks < 15 ? "Hệ thống đang tự động cập nhật trạng thái" : ""}</strong>
                        <small>{pollingChecks < 15 ? "Vui lòng giữ màn hình này mở và chờ kết quả xử lý." : "Bạn có thể bấm Kiểm tra lại để lấy trạng thái mới nhất."}</small>
                      </div>
                    </div>}
                    <strong className="request-processing-title">
                      {submittedRequest.status === "approved"
                        ? "Yêu cầu đã được xử lý thành công"
                        : submittedRequest.status === "removed"
                          ? "Yêu cầu đã bị từ chối"
                          : ["email", "phone_number"].includes(submittedRequest.send_type) && submittedRequest.verification_status !== "success"
                            ? "Yêu cầu đang chờ xác thực"
                            : pollingChecks < 15 ? "Yêu cầu đang được xử lý" : "Yêu cầu đang được xử lý lâu hơn dự kiến"}
                    </strong>
                    {/* <p className="submitted-request-code">Mã yêu cầu: <strong>{submittedRequest.request_code}</strong></p> */}
                    {(submittedRequest.note || submittedRequest.result) && <div className="request-result-note"><strong>Kết quả xử lý:</strong><HtmlNote html={submittedRequest.note || submittedRequest.result} /></div>}
                    <div className="request-progress">
                      <div className="request-progress-step step-complete"><span>1</span><small>Đã gửi yêu cầu</small></div>
                      <div className={`request-progress-step ${!["email", "phone_number"].includes(submittedRequest.send_type) || submittedRequest.verification_status === "success" ? "step-complete" : submittedRequest.verification_status === "invalid" ? "step-error" : "step-current"}`}><span>2</span><small>{["email", "phone_number"].includes(submittedRequest.send_type) ? "Xác thực" : "Đã tiếp nhận"}</small></div>
                      <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : ["email", "phone_number"].includes(submittedRequest.send_type) && submittedRequest.verification_status !== "success" ? "step-pending" : "step-current"}`}><span>3</span><small>Đang xử lý</small></div>
                      <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : "step-pending"}`}><span>4</span><small>Hoàn tất</small></div>
                    </div>
                    {submittedRequest.status === "no_process" && <div className="request-processing-message">
                      {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "email" && <p>Chưa nhận xác thực. Vui lòng gửi từ email đã liên kết.</p>}
                      {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "phone_number" && <p>Chưa nhận xác thực. Vui lòng gửi từ số điện thoại đã liên kết.</p>}
                      {submittedRequest.verification_status === "invalid" && <p>Xác thực không hợp lệ. Vui lòng kiểm tra thông tin và gửi lại.</p>}
                      {pollingChecks >= 15 && <><p>Yêu cầu đang xử lý lâu hơn dự kiến.</p><div className="request-processing-actions"><button type="button" onClick={refreshSubmittedRequest} disabled={isRefreshingRequest}>{isRefreshingRequest ? "Đang kiểm tra..." : "Kiểm tra lại"}</button><button type="button" onClick={copySubmittedRequestCode}>Sao chép mã</button></div></>}
                      {requestRefreshMessage && <p className="request-refresh-message" role="status">{requestRefreshMessage}</p>}
                    </div>}
                  </div>}
                  {/* <div style={{ marginTop: "15px" }}>
                    <p className="text-confirm-bottom">Vui lòng nhấn Xác nhận sau khi đã gửi thành công</p>
                    <button onClick={openModalSuccess} className="btn-send-mail">
                      XÁC NHẬN ĐÃ GỬI
                    </button>
                  </div> tạm thời không xử lý xác nhận đã gửi*/}
                  <div className="notification">
                    {/* <p
                      style={{
                        color: "#F7B922",
                        padding: "3px 0px",
                        margin: "0px",
                      }}
                    >
                      Lưu ý:
                    </p>
                    <p
                      style={{
                        display: user.send_type === "files" ? "none" : "block",
                      }}
                    >
                      - Sau khi nhận được {isSendMail ? "email" : "tin nhắn"},
                      hệ thống xét duyệt từ 2-5 phút.
                    </p>
                    <p>
                      - Quý khách vui lòng kiểm tra kết quả xử lý của hệ thống
                      tại Hòm Thư.
                    </p> */}
                    <p>
                      - Liên hệ{" "}
                      <a
                        href={webSetting?.link_cskh}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        CSKH
                      </a>{" "}
                      nếu cần hỗ trợ thêm.
                    </p>
                  </div>
                </div>
              </motion.div>
            </Popup>
            <Popup
              open={openResult}
              onClose={() => setOpenResult(false)}
              position={"center"}
            >
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="modal-success"
              >
                <div className="modal-close">
                  <a
                    className="icon-close"
                    onClick={() => setOpenResult(false)}
                  >
                    <img src={iconClose} alt="icon-close" />
                  </a>
                </div>
                {checkConfirm ? (
                  <div className="modal-result-content">
                    <img
                      style={{ marginBottom: "20px" }}
                      src={iconSuccess}
                      alt="icon-success"
                    />
                    <span>
                      Chúng tôi đã nhận được yêu cầu của Quý khách, vui lòng chờ
                      2-5 phút và nhận kết quả phản hồi tại Hòm thư nội bộ
                    </span>
                  </div>
                ) : (
                  <div className="modal-result-content">
                    <img
                      style={{ marginBottom: "20px" }}
                      src={iconWarning}
                      alt="icon-success"
                    />
                    <span>
                      Yêu cầu của bạn chưa được ghi nhận, vui lòng thử lại hoặc
                      liên hệ chăm sóc khách hàng
                    </span>
                  </div>
                )}
              </motion.div>
            </Popup>
            <Popup
              open={openUploadFile}
              onClose={() => setOpenUploadFile(false)}
              position={"center"}
            >
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="modal-success"
              >
                <div className="modal-close">
                  <a
                    className="icon-close"
                    onClick={() => setOpenUploadFile(false)}
                  >
                    <img src={iconClose} alt="icon-close" />
                  </a>
                </div>
                <div className="modal-result-content">
                  <img
                    style={{ marginBottom: "20px" }}
                    src={iconWarning}
                    alt="icon-success"
                  />
                  <span>
                    Bạn cần cung cấp thêm hình ảnh, video để xác minh thông tin.
                  </span>
                  <div className="upload-file" style={{ padding: "10px" }}>
                    <div
                      className="upload-file"
                      dangerouslySetInnerHTML={{ __html: infoFileUpload }}
                    />
                    <input
                      type="file"
                      ref={fileInputRef}
                      accept="image/*, video/*" // Chỉ chấp nhận ảnh hoặc video
                      onChange={handleFileChange}
                      multiple // Cho phép chọn nhiều file
                      style={{ opacity: 0 }} // Ẩn input file mặc định
                      // capture="user"//nhập trực tiếp từ camera
                    />

                    <Button
                      variant="contained"
                      onClick={handleButtonClick}
                      sx={{
                        backgroundColor: "#f82828",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "#11a0ff",
                        },
                        margin: "0px 36px",
                      }}
                    >
                      <FileUploadOutlinedIcon />
                      Chọn hình ảnh video
                    </Button>
                    {/* Hiển thị danh sách files đã chọn */}
                    <ul>
                      {selectedFiles.map((file, index) => (
                        <li key={index}>
                          {file.name}
                          <DeleteIcon
                            onClick={() => removeFile(index)}
                            sx={{
                              color: "red",
                              cursor: "pointer",
                              verticalAlign: "middle",
                              "&:hover": {
                                color: "darkred",
                              },
                            }}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                  {selectedFiles.length > 0 && (
                    <Button
                      variant="contained"
                      onClick={() => {
                        setOpenUploadFile(false);
                        updateUser(user.send_type);
                      }}
                      sx={{
                        backgroundColor: "#f82828",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "darkred",
                        },
                        margin: "0px 36px",
                      }}
                    >
                      Đã chọn file
                    </Button>
                  )}
                </div>
              </motion.div>
            </Popup>
          </div>
          <img src={post} alt="post" className="post-image" />
        </motion.div>
      </div>
    );
  }
}

export default Profile;
